import { IMPERATIVE_NAVIGATE_ID } from '../constants';

export const ImperativeNavigateLink = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement>,
) => {
  return (
    <a id={IMPERATIVE_NAVIGATE_ID} style={{ display: 'hidden' }} {...props}></a>
  );
};
